<script setup lang="ts">
import ProfilesList from '@/components/ProfilesList.vue'
import OGHeader from '@/components/OGHeader.vue'
import { useAppStore, type Profile } from '@/stores/appStore'
import { computed, ref } from 'vue'

const appStore = useAppStore()
const searchQuery = ref('')

const profiles = computed(() => {
  const ids: number[] = []
  const uniqueProfiles: Profile[] = []
  for (const profile of appStore.profiles) {
    if (!ids.includes(profile.personID) && profile.Person && profile.Person.linkedinUsername !== 'notFound') {
      ids.push(profile.personID)
      uniqueProfiles.push(profile)
    }
  }
  return uniqueProfiles
})

const filteredProfiles = computed(() => {
  if (!searchQuery.value) return profiles.value

  const query = searchQuery.value.toLowerCase()
  return profiles.value.filter((profile) => {
    if (!profile.Person) return false

    const fullName = `${profile.Person.firstName || ''} ${profile.Person.lastName || ''}`.toLowerCase()
    const email = profile.Person.email?.toLowerCase() || ''
    const jobTitle = profile.Person.jobTitle?.toLowerCase() || ''
    const companyName = profile.Person.companyName?.toLowerCase() || ''

    return fullName.includes(query) || email.includes(query) || jobTitle.includes(query) || companyName.includes(query)
  })
})
</script>

<template>
  <OGHeader title="People Profiles" subtitle="People you are meeting with" />

  <div class="q-pa-md">
    <q-input v-model="searchQuery" dense outlined placeholder="Search profiles..." class="q-mb-md">
      <template v-slot:append>
        <q-icon name="mdi-magnify" />
      </template>
    </q-input>
  </div>

  <ProfilesList :profiles="filteredProfiles" :compact="false" :max-view="null" />
</template>
